export default {
	__id			  : 'header',
	_previousScrollTop: null,
	_threshold        : 100,
	classHidden       : 'header--hidden',
	classLoaded       : 'header--loaded',
	header            : null,
	main              : null,
	init() {
		this.header = document.querySelector('[data-header]');
		if (!this.header) {
			return;
		}

		window.addEventListener('load', () => {
			this.adjustBody();
			this.checkScroll();
			this.header.classList.add(this.classLoaded);
			window.addEventListener('scroll', this.checkScroll.bind(this));
			window.addEventListener('orientationchange', this.adjustBody.bind(this));
		});
	},
	checkScroll() {
		const scrollTop         = window.pageYOffset || document.documentElement.scrollTop;
		const scrollingUpwards  = scrollTop < this._previousScrollTop;
		const isHidden          = this.isHidden();
		const shouldHide        = this.shouldHide();
		this._previousScrollTop = scrollTop;

		if (!shouldHide) {
			this.header.classList.remove(this.classHidden);
		}

		if (scrollingUpwards) {
			if (isHidden) {
				this.header.classList.remove(this.classHidden);
			}
			return;
		}

		if (isHidden || !shouldHide) {
			return;
		}

		this.header.classList.add(this.classHidden);
	},
	isHidden() {
		return this.header.classList.contains(this.classHidden);
	},
	shouldHide() {
		return this._previousScrollTop && this._previousScrollTop >= this._threshold;
	},
	adjustBody() {
		const contactBlock = document.querySelector('[data-contact-block]');
		
		if (contactBlock) {
			contactBlock.style.marginTop = `${this.header.clientHeight}px`;
		}
	},
	onScroll() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(this.checkScroll.bind(this), 10);
	}
};